<template>
  <vs-sidebar
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="sidebarView.isOpen"
    click-not-close
    id="view-notify"
  >
    <div class="flex items-center justify-between px-6 py-6">
      <h4 class="p-0 text-2xl font-bold">Notification</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-tabs id="noti-tabs">
      <vs-tab label="Appointment" @click="activeTab('appointment')">
        <div
          v-for="(noti, index) in notiAppointmentList.items"
          :key="index"
          class="px-6 py-2 border-bottom-custom cursor-pointer"
          :style="getColorNoti(noti)"
          @click="markAsReadAppointment(noti)"
        >
          <div class="flex justify-center justify-between w-full mt-1 align-center">
            <div class="flex align-left">
              <vs-alert
                :color="getNotiTypeColor(noti.type)"
                class="flex align-center justify-center"
                style="width: 90px; height: 25px !important; font-size: 12px"
              >{{noti.type}}</vs-alert>
            </div>
            <div class="text-sm">{{dateAgo((noti.created_at))}}</div>
          </div>
          <div class="mt-2 mb-1 text-sm break-word">{{noti.content}}</div>
        </div>
      </vs-tab>
      <!-- <vs-tab label="Call history" @click="activeTab('call history')">
        <div
          v-for="(noti, index) in callHistoryList.items"
          :key="index"
          class="px-6 py-4 border-bottom-custom cursor-pointer"
          :class="{'text-danger': noti.status == 'missed_call'}"
          :style="getColorNoti(noti)"
          @click="markAsReadAppointment(noti)"
        >
          <div class="flex justify-center justify-between w-full mt-1 align-center">
            <div class="pr-2">
              <p class="mb-1 font-bold calling-name" :class="`${noti.status == 'missed_call' ? 'text-danger' : 'text-black'}`">{{ noti.name }}</p>
              <div class="flex align-center">
                <p class="text-sm"><feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1 font-bold" />{{ StringHelper.phoneNumberFormat("1234565679") }}</p>
                <vs-alert v-if="noti.status" :color="getCallingColorByStatus(noti.status)" class="flex align-center justify-center ml-3"
                  style="width: 90px; height: 30px !important; font-size: 12px"
                >{{ getCallingTextByStatus(noti.status) }}</vs-alert>
              </div>
            </div>
            <div class="text-sm text-right flex flex-col justify-between">
              <p>{{dateAgo((noti.created_at))}}</p>
              <p class="text-sm mt-2">{{ formatDateTime(noti.created_at) }}</p>
            </div>
          </div>
        </div>
      </vs-tab> -->
      <vs-tab label="System" @click="activeTab('system')">
        <div
          v-for="(noti, index) in notiSystem.items"
          :key="index"
          class="px-6 py-2 border-bottom-custom cursor-pointer"
          :style="getColorNoti(noti)"
          @click="markAsReadSystem(noti)"
        >
          <div class="flex justify-center justify-between w-full mt-1 align-stretch">
            <!-- <div class="flex align-left"></div> -->
            <div class="pr-4 system-noti-content">
              <div class="mb-1 font-bold">{{noti.title}}</div>
              <div class="mt-2 mb-1 text-sm break-word">{{noti.description}}</div>
            </div>
            <div class="text-sm text-right w-max-content">{{dateAgo((noti.created_at))}}</div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <vs-divider class="mb-0"></vs-divider>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <span
        @click="viewAll"
        class="justify-center"
        style="color:#2979FF; cursor: pointer;"
      >View all {{tab}}<span v-if="tab != 'call history'"> notifications</span></span>
    </div>
  </vs-sidebar>
</template>

<script>
import { changeFormatWithDateTime } from '../../helper/datetimeHelper';
import { StringHelper } from '../../models/string_helper';
export default {
  name: "vs-view-notify",
  props: {
    sidebarView: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      StringHelper,
      notiAppointmentList: [],
      notiSystem: [],
      callHistoryList: {
        items: [
          { id: 1, name: 'Ly Le', phone: '1234565679', created_at: new Date(), is_read: 1, status: 'booked' },
          { id: 2, name: 'Tammy', phone: '1234565679', created_at: new Date(), is_read: 0, status: null },
          { id: 3, name: 'Harry', phone: '1234565679', created_at: new Date(), is_read: 1, status: null },
          { id: 4, name: 'Unknown', phone: '1234565679', created_at: new Date(), is_read: 1, status: 'missed_call' },
          { id: 5, name: 'Lilly', phone: '1234565679', created_at: new Date(), is_read: 1, status: 'booked' },
          { id: 6, name: 'Nicole', phone: '1234565679', created_at: new Date(), is_read: 1, status: null }
        ]
      },
      tab: "appointment",
      key: this.$route.query.key ? parseInt(this.$route.query.key) + 1 : 0
    };
  },
  watch: {
    sidebarView: {
      immediate: true,
      deep: true,
      handler() {
        if (this.sidebarView.isOpen) {
          document.body.classList.add("overflow-hidden");
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#view-notify",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Mask as read failed",
            acceptText: "OK"
          });
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout(() => {
        this.$vs.loading.close("#view-notify > .con-vs-loading");
      }, 500);
    },
    formatDateTime(date) {
      if(date) {
        return changeFormatWithDateTime(date);
      }
      return 'N/A';
    },
    getColorNoti(noti) {
      if (noti.is_read == 0) {
        return "background-color: aliceblue";
      }
      return "";
    },
    markAsReadSystem(noti) {
      const obj = {
        type: "normal",
        id: noti.id
      };
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("notify/MARK_AS_READ", obj).then(() => {
        this.closeLoading();
        const obj = {
          page: 1,
          "per-page": 20
        };
        this.$store.dispatch("notify/NOTIFY_SYSTEM", obj).then(() => {
          this.notiSystem = this.$store.state.notify.notifySystemList;
        });
      });
    },
    markAsReadAppointment(noti) {
      const obj = {
        type: "appointment",
        id: noti.id
      };
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("notify/MARK_AS_READ", obj).then(() => {
        const obj = {
          page: 1,
          "per-page": 20
        };
        this.$router.push(
          {
            name: "appointment",
            query: { key: this.key++ },
            params: { id: noti.appointment_id }
          },
          () => {
            this.closeLoading();
            this.sidebarView.isOpen = false;
          }
        );
        this.$emit('OutViewNotify', 'appointment');
        this.$store.dispatch("notify/NOTIFY_APPOINTMENT", obj).then(() => {
          this.notiAppointmentList = this.$store.state.notify.notifyList;
        });
      });
    },
    dateAgo(created_at) {
      let create = new Date(created_at);
      let currentDate = new Date();
      let type = "";
      let Difference_In_Time = currentDate.getTime() - create.getTime();
      let Difference_In_Day = 0;
      let Difference_In_Days = Difference_In_Time / (1000 * 3600);
      if (Difference_In_Days < 24) {
        Difference_In_Day = Difference_In_Days;
        type = "h ago";
      }
      if (Difference_In_Days >= 24) {
        Difference_In_Day = Difference_In_Days / 24;
        type = " days ago";
      }
      if (Difference_In_Days >= 720) {
        Difference_In_Day = Difference_In_Days / 720;
        type = " months ago";
      }
      if (Difference_In_Days >= 720 * 12) {
        Difference_In_Day = Difference_In_Days / (720 * 12);
        type = " years ago";
      }
      return Math.round(Difference_In_Day) + type;
    },
    viewAll() {
      let currentTab = this.tab;
      if(this.tab == 'call history') {
        currentTab = 'call-history';
      }
      this.$router
        .push({ path: "/notify/" + currentTab })
        .then(() => {
          this.sidebarView.isOpen = false;
          this.$emit('OutViewNotify', 'setting');
        })
        .catch(() => {
          this.sidebarView.isOpen = false;
          this.$emit('OutViewNotify', 'setting');
        });
    },
    closeSidebar() {
      this.sidebarView.isOpen = false;
      this.$emit("Unread");
    },
    getNotiTypeColor(noti_type) {
      if (noti_type == "scheduled") return "success";
      if (noti_type == "confirmed") return "primary";
      if (noti_type == "done") return "warning";
      if (noti_type == "canceled") return "danger";
      return "dark";
    },
    getCallingColorByStatus(status) {
      if(status == 'booked') return "primary";
      if(status == 'missed_call') return "danger";
      return "dark";
    },
    getCallingTextByStatus(status) {
      if(status == 'booked') return "Booked";
      if(status == 'missed_call') return "Missed call";
      return "N/A";
    },
    activeTab(current) {
      this.tab = current;
    }
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  created() {
    const obj = {
      page: 1,
      "per-page": 20
    };
    this.$store.dispatch("notify/NOTIFY_APPOINTMENT", obj).then(() => {
      this.notiAppointmentList = this.$store.state.notify.notifyList;
    });
    this.$store.dispatch("notify/NOTIFY_SYSTEM", obj).then(() => {
      this.notiSystem = this.$store.state.notify.notifySystemList;
    });
  }
};
</script>